var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"paypal"},[_c('Portal',{attrs:{"to":"paypal-buttons"}},[_c('div',{attrs:{"id":_vm.buttonsContainer}})]),_vm._v(" "),_c('p',{attrs:{"data-test-id":"billing-info-notice"}},[_vm._v("\n    "+_vm._s(_vm.$t('shared.billing.paypal.billing_info_notice'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }